<template>
  <div class="contents">
    <div class="container-fluid p-0">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h4 class="fw-500">🔐 Laporan Passkey</h4>
      </div>
      <p class="text-muted">Device yang ditautkan lewat fitur <b>“Tautkan dengan Passkey”</b> (berada di node passkey), beserta akun pemiliknya.</p>

      <!-- Summary cards -->
      <div class="row" v-if="summary">
        <div class="col-md-4 col-sm-6 mb-3">
          <div class="card p-3" style="border-left:4px solid #4f46e5">
            <div class="text-muted small">📱 TOTAL DEVICE PASSKEY</div>
            <div class="h4 mb-0 font-weight-bold text-primary">{{ summary.count }}</div>
            <small class="text-muted">device di node passkey</small>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 mb-3">
          <div class="card p-3" style="border-left:4px solid #2e7d32">
            <div class="text-muted small">✅ TERKONEKSI</div>
            <div class="h4 mb-0 font-weight-bold" style="color:#2e7d32">{{ summary.connected }}</div>
            <small class="text-muted">berhasil tertaut via passkey</small>
          </div>
        </div>
      </div>

      <!-- Search -->
      <div class="row mb-2"><div class="col-12"><div class="card p-3">
        <div class="d-flex align-items-center" style="gap:8px;flex-wrap:wrap">
          <span class="font-weight-bold">Cari:</span>
          <input v-model="q" type="text" class="form-control form-control-sm" style="width:280px" placeholder="akun / device / nomor" />
          <button @click="load" class="btn btn-sm btn-outline-primary">Refresh</button>
        </div>
      </div></div></div>

      <!-- Table -->
      <div class="row"><div class="col-12">
        <div class="card global-shadow border bg-white radius-xl w-100 mb-30">
          <div v-if="isLoading" class="text-center p-4">
            <div class="spinner-border" role="status"></div><p class="mt-2 text-muted">Loading...</p>
          </div>
          <div v-else-if="!filtered.length" class="text-center text-muted p-4"><p>Belum ada device passkey.</p></div>
          <div v-else class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="bg-light"><tr>
                <th>#</th><th>Akun</th><th>Device</th><th>Nomor</th><th>Paket</th><th>Masa Aktif</th><th class="text-center">Status</th><th class="text-center">Node</th>
              </tr></thead>
              <tbody>
                <tr v-for="(r, i) in filtered" :key="r.device_id">
                  <td>{{ i + 1 }}</td>
                  <td><div class="font-weight-bold">{{ r.user_name || '-' }}</div><small class="text-muted">{{ r.user_email }}</small></td>
                  <td>{{ r.device_name }}</td>
                  <td>{{ r.no_hp || '-' }}</td>
                  <td><span class="badge badge-light">{{ r.package_name || '-' }}</span></td>
                  <td>
                    <span :class="isActive(r.expired_at) ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">{{ fmtDate(r.expired_at) }}</span>
                    <br><small :class="isActive(r.expired_at) ? 'text-success' : 'text-danger'">{{ r.expired_at ? (isActive(r.expired_at) ? 'aktif' : 'expired') : '' }}</small>
                  </td>
                  <td class="text-center"><span :class="r.status === 'connected' ? 'badge badge-success' : 'badge badge-secondary'">{{ r.status }}</span></td>
                  <td class="text-center"><small>#{{ r.server_id }}</small></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return { isLoading: false, summary: null, rows: [], q: "" };
  },
  computed: {
    filtered() {
      if (!this.q) return this.rows;
      const s = this.q.toLowerCase();
      return this.rows.filter(
        (r) =>
          (r.user_email || "").toLowerCase().includes(s) ||
          (r.user_name || "").toLowerCase().includes(s) ||
          (r.device_name || "").toLowerCase().includes(s) ||
          (r.no_hp || "").includes(s)
      );
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.isLoading = true;
      try {
        const r = await axios.get("admin/passkey-report");
        const d = r.data.data || {};
        this.summary = { count: d.count, connected: d.connected };
        this.rows = d.data || [];
      } catch (err) {
        this.$toast.error("Gagal load: " + (err.response?.data?.message || err.message));
      } finally {
        this.isLoading = false;
      }
    },
    fmtDate(ms) {
      if (!ms) return "-";
      return new Date(Number(ms)).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
    },
    isActive(ms) {
      return ms && Number(ms) > Date.now();
    },
  },
};
</script>
